export default __webpack_public_path__ + "static/media/epoc.b4f5aa10.pdf";